import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import { formatearDireccionEntrega } from "../Components/PdfComponents/formatearDireccionEntrega";
import { BloqueFirmasPdf } from "../Components/PdfComponents/BloqueFirmasPdf";
import pedidoPdfV2 from "./PdfV2.0/pedidoPdfV2";


moment.locale("es");

const pedidoPdf = (values) => {
  const empresa = values.respuestaFactura.empresa;

  if (empresa.tipoPDF === "moderno") return pedidoPdfV2(values);

  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || values.quitarImpuestos || false;
  const ocultarColumnaIVA = empresa?.ocultarColumnaIVA || false;
  const cantidadJuntoPrecioUnitario = empresa?.cantidadJuntoPrecioUnitario || false;
  const dataSat = values.respuestaFactura.dataSat;
  const direccionEntrega =
    values.respuestaFactura?.dataSat?.direccionEntrega || null;
  let agregarImpDesc = 0;
  const mostrarDescUnidad = empresa?.imprimirDesUnidad;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const mostrarTipoComprobante = !empresa?.deshabilitarTipoComprobantePdf;
  const mostrarMoneda = !empresa?.deshabilitarMonedaPdf;
  const mostrarLugarExpedicion = !empresa?.deshabilitarLugarExpedicionPdf;
  const mostrarCondicionesPago = !empresa?.deshabilitarCondicionesPagoPdf;
  const mostrarMetodoPago = !empresa?.deshabilitarMetodoPagoPdf;
  const mostrarOC = !empresa?.deshabilitarOCPdf;
  const mostrarFecha = !empresa?.deshabilitarFechaPdf;
  const mostrarFechaEntrega = !empresa?.deshabilitarFechaEntregaPdf;
  const ocultarColumnaPU = !!empresa?.ocultarColumnaPU && !dataSat?.mostrarPrecio;
  const ocultarColumnaImporte = !!empresa?.ocultarColumnaImporte && !dataSat?.mostrarPrecio;
  // Columna con el P/U ya descontado, a la derecha del P/U
  const precioUnitarioConDescuento = empresa?.precioUnitarioConDescuento === true && !ocultarColumnaPU;
  const widthPUConDescuento = 9;
  const mostrarCuadroTotales = !empresa?.ocultarCuadroTotalesPdf || !!dataSat?.mostrarTotales;
  const { referencia: referenciaEntrega, direccion: direccionEntregaTexto } = formatearDireccionEntrega(
    direccionEntrega,
    { mostrarReferencia: !!empresa?.mostrarReferenciaEntregaPdf }
  );
  const proyecto = values.respuestaFactura?.dataSat?.proyecto || [];
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };

  // Ocultar clave y clave SAT
  const mostrarClaveSAT = !empresa?.deshabilitarClaveSATCot; 
  const mostrarClave = !empresa?.deshabilitarClaveCot; 

  const widthClaveSAT = quitarImpuestosRemisiones ? 8 : 9;
  const widthClave = quitarImpuestosRemisiones ? 9 : 12;
  const widthIEPS = 8;
  const widthIVA = 8;
  const widthPU = quitarImpuestosRemisiones ? 15 : 10.5;
  const widthImporte = quitarImpuestosRemisiones ? 15 : 12.5;

  let widthExtraDescripcion = 0;
  //Agregar los anchos que no se muestran a la descripción
  if(!mostrarClaveSAT) widthExtraDescripcion += widthClaveSAT;
  if(!mostrarClave) widthExtraDescripcion += widthClave;
  if (!quitarImpuestosRemisiones && !empresa.imprimirIEPS) {
      widthExtraDescripcion += widthIEPS;
  }
  if (!quitarImpuestosRemisiones && ocultarColumnaIVA) {
      widthExtraDescripcion += widthIVA;
  }
  if (ocultarColumnaPU) widthExtraDescripcion += widthPU;
  if (ocultarColumnaImporte) widthExtraDescripcion += widthImporte;

  const widthExtraCantidad = Math.round(widthExtraDescripcion * 0.05 * 10) / 10;
  const widthExtraUnidad = Math.round(widthExtraDescripcion * 0.15 * 10) / 10;
  const widthExtraClave = mostrarClave ? Math.round(widthExtraDescripcion * 0.15 * 10) / 10 : 0;
  const widthExtraDescripcionFinal = Math.round((widthExtraDescripcion - widthExtraCantidad - widthExtraUnidad - widthExtraClave) * 10) / 10;

  const conceptos = dataSat.Conceptos.map((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    let agregarImpConcepto = 0;
    let relacionDescuento =
      Number(valueConcepto.Descuento) / Number(valueConcepto.Importe);
    valueConcepto.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
        agregarImpConcepto +=
          valueImpuesto.Importe / (1 - relacionDescuento) -
          valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
        agregarImpConcepto +=
          valueImpuesto.Importe / (1 - relacionDescuento) -
          valueImpuesto.Importe;
      }
      return null;
    });
    agregarImpDesc += agregarImpConcepto;
    // P/U menos el descuento del renglón, en la misma base que la columna P/U
    const precioUnitarioNeto = quitarImpuestosRemisiones
      ? (Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps) / Number(valueConcepto.Cantidad || 1)
      : Number(valueConcepto.ValorUnitario) - Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Cantidad || 1);
    const celdaCantidad = {
      style: "textoTablaChico",
      text: formatCantidad(valueConcepto.Cantidad),
      alignment: "right",
    };
    return [
      { style: "textoTablaChico", text: index + 1, alignment: "center" },
      ...(cantidadJuntoPrecioUnitario ? [] : [celdaCantidad]),
      {
        text: (() => {
          const textoUnidad = (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad; //clave unidad
          return valueConcepto.presentacionCliente || textoUnidad;
        })(),
        style: "textoTablaChico",
        alignment: "center",
      },
       ...(mostrarClaveSAT ? [{
          text: valueConcepto.ClaveProdServ,
          style: "textoTablaChico",
          alignment: "center",
        }] : []),
        ...(mostrarClave ? [{
          text: valueConcepto.NoIdentificacion,
          style: "textoTablaChico",
          alignment: "center",
        }] : []),
      (() => {
        const textoDescSinObs =
          valueConcepto.Descripcion +
          (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
          (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
          (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
        const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
        const tieneLotes = Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0;
        const tieneComponentesKit = Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0;
        if (tieneLotes || tieneComponentesKit || valueConcepto.DescripcionLarga) {
          // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
          const stackExtra = valueConcepto.DescripcionLarga
            ? [
              { text: textoDescSinObs, style: "textoTablaChico" },
              { text: valueConcepto.DescripcionLarga, fontSize: 5, color: "#555", margin: [0, 1, 0, 0] },
              ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
            ]
            : [{ text: textoDesc, style: "textoTablaChico" }];
          if (tieneLotes) {
            stackExtra.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: 5, color: "#555", margin: [0, 2, 0, 0] });
          }
          if (tieneComponentesKit) {
            stackExtra.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: 5, color: "#555", margin: [0, 2, 0, 0] });
          }
          return {
            stack: stackExtra,
            alignment: "left",
          };
        }
        return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
      })(),
      ...(cantidadJuntoPrecioUnitario ? [celdaCantidad] : []),
      ...(ocultarColumnaPU ? [] : [{
        stack: [
          {
            text: dineroDisabledMask(
              quitarImpuestosRemisiones
                ? (Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto) / Number(valueConcepto.Cantidad || 1)
                : valueConcepto.ValorUnitario,
              decimalesPrecioUnitarioPdf
            ),
            style: "textoTablaChico",
            alignment: "right",
          },

          ...(
            !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [

                {
                  columns: [
                    {
                      text:
                        round2Decimals(
                          (Number(valueConcepto.Descuento) * 100) /
                          (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))
                        ) + "%:",
                      width: "*",
                      alignment: "left",
                      style: "descuentoPartida",
                      noWrap: true,
                    },
                    {
                      text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento /
                        (Number(valueConcepto.Cantidad || 1)))),
                      width: "auto",
                      alignment: "right",
                      style: "descuentoPartida",
                      noWrap: true,
                    }
                  ],
                  columnGap: 8,
                  margin: [0, 2, 0, 0]
                }]
              : []
          )
        ]
      }]),
      ...(precioUnitarioConDescuento ? [{
        text: dineroDisabledMask(precioUnitarioNeto, decimalesPrecioUnitarioPdf),
        style: "textoTablaChico",
        alignment: "right",
      }] : []),
      ...(quitarImpuestosRemisiones
        ? []
        : [
          ...(ocultarColumnaIVA
            ? []
            : [{
              text: dineroDisabledMask(quitarImpuestosRemisiones ? 0 : iva),
              style: "textoTablaChico",
              alignment: "right",
            }]),
          ...(empresa.imprimirIEPS
            ? [
              {
                text: dineroDisabledMask(ieps),
                style: "textoTablaChico",
                alignment: "right",
              },
            ]
            : []),
        ]),
      ...(ocultarColumnaImporte ? [] : [{
        stack: [
          {
            text: dineroDisabledMask(
              quitarImpuestosRemisiones
                ? Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto
                : valueConcepto.Importe
            ),
            style: "textoTablaChico",
            alignment: "right",
          },

          ...(
            !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [{
                text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)),
                style: "descuentoPartida",
                alignment: "right",
                margin: [0, 2, 0, 0]
              }]
              : []
          )
        ]
      }]),
    ];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [
      ...dataSat.Impuestos.Traslados,
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:TrasladosLocales"
      ] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:TrasladosLocales"
      ] || []),
    ];

  let totalImpuestos = 0;

  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA =
      a.Impuesto === "002"
        ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
        : a.Impuesto === "003"
          ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
          : a["@ImpLocTrasladado"];
    const nombreB =
      b.Impuesto === "002"
        ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
        : b.Impuesto === "003"
          ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
          : b["@ImpLocTrasladado"];

    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map(
    (valueImpuesto, indexImpuesto) => {
      let nombre = "";
      if (valueImpuesto.Impuesto === "002") {
        nombre = "IVA";
      } else if (valueImpuesto.Impuesto === "003") {
        nombre = "IEPS";
      } else {
        nombre = valueImpuesto["@ImpLocTrasladado"];
      }

      if (valueImpuesto.TipoFactor === "Tasa") {
        nombre =
          nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
      } else if (valueImpuesto.TipoFactor === "Cuota") {
        nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
      }
      totalImpuestos += valueImpuesto.Importe || valueImpuesto["@Importe"];

      let border = indexImpuesto + 1 === nuevoArrayImpFLOdenado.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(
            valueImpuesto.Importe || valueImpuesto["@Importe"] || 0
          ),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  );

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [
      ...dataSat.Impuestos.Retenciones,
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:RetencionesLocales"
      ] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:RetencionesLocales"
      ] || []),
    ];

  const retencionesTotales = nuevoArrayRetFL.map(
    (valueRetencion, indexRetencion) => {
      let nombre = "Retención ";
      if (valueRetencion.Impuesto === "001") {
        nombre = nombre + "ISR";
      } else if (valueRetencion.Impuesto === "002") {
        nombre = nombre + "IVA";
      } else {
        nombre = valueRetencion["@ImpLocRetenido"];
      }

      let border = indexRetencion + 1 === nuevoArrayRetFL.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(
            valueRetencion.Importe || valueRetencion["@Importe"]
          ),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  );

  const totalImpFL =
    dataSat.Impuestos.TotalImpuestosTrasladados +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
      "@TotaldeTraslados"
    ] || 0) || 0;
  const totalRetFL =
    dataSat.Impuestos.TotalImpuestosRetenidos +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
      "@TotaldeRetenciones"
    ] || 0) || 0;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = {
      watermark: {
        text: "CANCELADO",
        color: "GRAY",
        opacity: 0.3,
        bold: true,
        italics: false,
        angle: -50,
        fontSize: 110,
      },
    };
  }

  const mostrarBancos = !dataSat?.deshabilitarBanco;
  const filasBanco1 = [
    [
      {
        border: [true, true, false, false],
        text: "Banco:",
        style: "subheader",
      },
      {
        border: [false, true, true, false],
        text: empresa.banco ? empresa.banco : "",
        style: "textoChico",
      },
    ],
    ...(empresa.swiftCode
      ? [
        [
          {
            border: [true, false, false, false],
            text: "Swift Code:",
            style: "subheader",
          },
          {
            border: [false, false, true, false],
            text: empresa.swiftCode ? empresa.swiftCode : "",
            style: "textoChico",
          },
        ],
      ]
      : []),
    ...(empresa.abaCode
      ? [
        [
          {
            border: [true, false, false, false],
            text: "ABA Code:",
            style: "subheader",
          },
          {
            border: [false, false, true, false],
            text: empresa.abaCode ? empresa.abaCode : "",
            style: "textoChico",
          },
        ],
      ]
      : []),
    [
      {
        border: [true, false, false, false],
        text: "Cuenta:",
        style: "subheader",
      },
      {
        border: [false, false, true, false],
        text: empresa.cuentaBanco ? empresa.cuentaBanco : "",
        style: "textoChico",
      },
    ],
    [
      {
        border: [true, false, false, true],
        text: "Cuenta CLABE:",
        style: "subheader",
      },
      {
        border: [false, false, true, true],
        text: empresa.cuentaClabe ? empresa.cuentaClabe : "",
        style: "textoChico",
      },
    ],
  ];
  let observaciones = {};
  if (values.imprimirObservaciones && values.observaciones) {
    observaciones = {
      table: {
        widths: ['*'],
        body: [
          [
            {
              border: [true, true, true, false],
              text: "Observaciones:",
              margin: [0, 0, 0, 5],
              style: "header",
            },
          ],
          [
            {
              border: [true, false, true, true],
              text: values.observaciones,
              margin: [0, 0, 0, 5],
              style: "textoChico",
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 1 : 1;
        },
        vLineWidth: function (i, node) {
          return i === 0 || i === node.table.widths.length ? 1 : 1;
        },
        hLineColor: function (i, node) {
          return "#adaaaa";
        },
        vLineColor: function (i, node) {
          return "#adaaaa";
        },
        hLineStyle: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return null;
          }
          return { dash: { length: 2, space: 1 } };
        },
        vLineStyle: function (i, node) {
          if (i === 0 || i === node.table.widths.length) {
            return null;
          }
          return { dash: { length: 2 } };
        },
      },
    };
  }

  const arraySiHayRetenciones =
    totalRetFL > 0
      ? [
        //   [
        //   {
        //     border: [true, false, false, false],
        //     text: "Retenciones:",
        //     style: "subheader",
        //   },
        //   {
        //     border: [false, false, true, false],
        //     text: dineroDisabledMask(
        //       totalRetFL
        //     ),
        //     style: "textoChico",
        //     alignment: "right",
        //   },
        // ],
        [
          {
            border: [true, false, false, true],
            text: "TOTAL PAGO:",
            style: "header",
            fillColor: "#e8e8e8",
          },
          {
            border: [false, false, true, true],
            text: dineroDisabledMask(dataSat.Total),
            style: "header",
            fillColor: "#e8e8e8",
            alignment: "right",
          },
        ],
      ]
      : [];

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;

  let vendedorTable = [];

  if (empresa.vendedorVentas && values.vendedor) {
    const vendedor = values.vendedor;
    vendedorTable.push([
      {
        colSpan: 2,
        table: {
          widths: ["17.5%", "82.5%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              { text: "Vendedor :", style: "subheader" },
              {
                text:
                  vendedor.nombre +
                  (vendedor.apellidoPaterno
                    ? " " + vendedor.apellidoPaterno
                    : "") +
                  (vendedor.apellidoMaterno
                    ? " " + vendedor.apellidoMaterno
                    : ""),
                style: "textoChico",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ]);
  }

  var dd = {
    ...cancelado,
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              ...HeaderEmpresaCard(empresa, mostrarRegimen, mostrarTipoComprobante,
                {
                  border: [false, false, false, false],
                  table: {
                    headerRows: 1,
                    widths: ["100%"],

                    body: [
                      [
                        {
                          text: "N° Pedido:",
                          style: "subheader",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text:
                            (dataSat.Serie ? dataSat.Serie : "C") +
                            " - " +
                            dataSat.Folio,
                          style: "textoChico",
                          alignment: "center",
                        },
                      ],
                      ...(mostrarMoneda ? [
                        [
                          {
                            text: "Moneda:",
                            style: "subheader",
                            alignment: "center",
                          },
                        ],
                        [
                          {
                            text: dataSat.Moneda,
                            style: "textoChico",
                            alignment: "center",
                          },
                        ],
                      ] : []),
                    ],
                  },
                  layout: "noBorders",
                }),
            ],
          ],
        },
      },
      {
        text:
          "Pedido N° " +
          (dataSat.Serie ? dataSat.Serie : "P") +
          " - " +
          dataSat.Folio,
        style: "tableHeaderIzquierda",
      },
      {
        style: "tableExample",
        table: {
          widths: ["60%", "40%"],
          layout: {
            defaultBorder: false,
          },

          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      { text: "Nombre del cliente :", style: "subheader" },
                      { text: dataSat.Receptor.Nombre, style: "textoChico" },
                    ],
                    ...(dataSat?.Receptor?.codigoProveedor
                      ? [[
                        { text: "Código Proveedor:", style: "subheader" },
                        { text: dataSat.Receptor.codigoProveedor, style: "textoChico" },
                      ]]
                      : []),
                    // [
                    //   { text: "Direccion :", style: "subheader" },
                    //   { text: "Variable", style: "textoChico" },
                    // ],
                    ...(mostrarFecha ? [[
                      { text: "Fecha:", style: "subheader" },
                      {
                        text: moment(dataSat.Fecha).locale("es").format("LL"),
                        style: "textoChico",
                      },
                    ]] : []),
                    ...(mostrarLugarExpedicion ? [[
                      { text: "Lugar de expedicion:", style: "subheader" },
                      { text: dataSat.LugarExpedicion, style: "textoChico" },
                    ]] : []),
                    ...(mostrarMetodoPago ? [[
                      { text: "Metodo de pago :", style: "subheader" },
                      {
                        text:
                          dataSat.MetodoPago === "PUE"
                            ? "PUE - Pago en una sola exhibición"
                            : "PPD - Pago en parcialidades o diferido",
                        style: "textoChico",
                      },
                    ]] : []),
                  ],
                },
                layout: "noBorders",
              },

              {
                table: {
                  widths: ["40%", "60%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: (() => {
                    const filas = [
                    ...(empresa?.mostrarProyectoVentas
                      ? [
                        [
                          { text: "Proyecto:", style: "subheader" },
                          {
                            text: proyecto,
                            style: "textoChico",
                          },
                        ],
                      ]
                      : []),
                    ...(mostrarOC ? [[
                      { text: "Orden de compra:", style: "subheader" },
                      { text: dataSat.pedido, style: "textoChico" },
                    ]] : []),
                    ...(dataSat.req
                      ? [
                        [
                          {
                            text: "Req: ",
                            style: "subheader",
                            alignment: "left",
                          },
                          { text: dataSat.req, style: "textoChico" },
                        ]
                      ]
                      : []),
                    ...(mostrarCondicionesPago ? [[
                      { text: "Condiciones de pago:", style: "subheader" },
                      {
                        text:
                          dataSat.condicion === 1
                            ? "Contado"
                            : "Crédito (" +
                            (dataSat?.Receptor?.diasCredito
                              ? dataSat?.Receptor?.diasCredito
                              : "0") +
                            " días)",
                        style: "textoChico",
                      },
                    ]] : []),
                    ...(referenciaEntrega
                      ? [[
                        { text: "Referencia:", style: "subheader" },
                        { text: referenciaEntrega, style: "textoChico" },
                      ]]
                      : []),
                    ...(direccionEntrega?.destino
                      ? [[
                        { text: "Destino:", style: "subheader" },
                        {
                          text: direccionEntrega?.destino,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(direccionEntrega?.embarque
                      ? [[
                        { text: "Embarque:", style: "subheader" },
                        {
                          text: direccionEntrega?.embarque,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(direccionEntregaTexto
                      ? [[
                        { text: "Dirección de Entrega:", style: "subheader" },
                        { text: direccionEntregaTexto, style: "textoChico" },
                      ]]
                      : []),
                    ...(mostrarFechaEntrega && dataSat.fechaEntregaEstimada
                      ? [[
                        { text: "Fecha de entrega estimada:", style: "subheader" },
                        {
                          text: moment(dataSat.fechaEntregaEstimada).locale("es").format("LL"),
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(dataSat?.atencion
                      ? [[
                        { text: "Atención a: ", style: "subheader" },
                        { text: dataSat?.atencion, style: "textoChico" },
                      ]]
                      : []),
                    ];
                    return filas.length
                      ? filas
                      : [[{ text: "" }, { text: "" }]];
                  })(),
                },
                layout: "noBorders",
              },
            ],
            ...vendedorTable,
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tableExample",
        table: {
          widths: quitarImpuestosRemisiones
            ? [
              "2%", //Número de item
              ...(cantidadJuntoPrecioUnitario ? [] : [`${7 + widthExtraCantidad}%`]), //Cantidad
              `${8 + widthExtraUnidad}%`, //Unidad
              ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),//"8%" Clave SAT
              ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),//"9%" Clave
              `${36 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`, //Descripción
              ...(cantidadJuntoPrecioUnitario ? [`${7 + widthExtraCantidad}%`] : []), //Cantidad
              ...(ocultarColumnaPU ? [] : ["15%"]), //P/U
              ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), //P/U c/Desc.
              ...(ocultarColumnaImporte ? [] : ["15%"]), //Importe
            ]
            : [
              "2%", //Número de item
              ...(cantidadJuntoPrecioUnitario ? [] : [`${4 + widthExtraCantidad}%`]), //Cantidad
              `${6 + widthExtraUnidad}%`, //Unidad
              ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),//"9%" Clave SAT
              ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),//"12%" Clave
              `${28 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
              ...(cantidadJuntoPrecioUnitario ? [`${4 + widthExtraCantidad}%`] : []), //Cantidad
              ...(ocultarColumnaPU ? [] : ["10.5%"]), //P/U
              ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), //P/U c/Desc.
              ...(ocultarColumnaIVA ? [] : ["8%"]), //IVA
              ...(empresa.imprimirIEPS ? ["8%"] : []), //IEPS
              ...(ocultarColumnaImporte ? [] : ["12.5%"]), //IMPORTE
            ],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              { text: "", style: "tituloTabla" },
              ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cant", style: "tituloTabla" }]),
              { text: "Unidad", style: "tituloTabla" },
              ...(mostrarClaveSAT ? [{ text: "Clave SAT", style: "tituloTabla" }] : []),
              ...(mostrarClave ? [{ text: "Clave", style: "tituloTabla" }] : []),
              { text: "Descripción", style: "tituloTabla" },
              ...(cantidadJuntoPrecioUnitario ? [{ text: "Cant", style: "tituloTabla" }] : []),
              ...(ocultarColumnaPU ? [] : [{ text: "P/U", style: "tituloTabla" }]),
              ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.", style: "tituloTabla" }] : []),
              ...(quitarImpuestosRemisiones
                ? []
                : [
                  ...(ocultarColumnaIVA ? [] : [{ text: "IVA", style: "tituloTabla" }]),
                  ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
                ]),
              ...(ocultarColumnaImporte ? [] : [{ text: "Importe", style: "tituloTabla" }]),
            ],
            ...conceptos,
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tablaSinMargen",
        table: {
          widths: mostrarCuadroTotales ? ["70%", "30%"] : ["100%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: (() => {
                    const filas = [
                      ...(mostrarCuadroTotales ? [[
                        {
                          border: [true, true, false, !mostrarBancos],
                          text: "Cantidad con letra:",
                          style: "subheader",
                        },
                        {
                          border: [false, true, true, !mostrarBancos],
                          text:
                            "**( " +
                            numeroALetra(dataSat.Total, dataSat.Moneda) +
                            " )**",
                          style: "textoChico",
                          fontSize: 7,
                        },
                      ]] : []),
                      ...(mostrarBancos ? filasBanco1 : []),
                    ];
                    return filas.length
                      ? filas
                      : [[{ text: "", border: [false, false, false, false] }, { text: "", border: [false, false, false, false] }]];
                  })(),
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
              ...(mostrarCuadroTotales ? [{
                table: {
                  widths: ["35%", "65%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Subtotal:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: dineroDisabledMask(
                          quitarImpuestosRemisiones
                            ? dataSat.SubTotal + totalImpuestos + agregarImpDesc
                            : dataSat.SubTotal
                        ),
                        style: "textoChico",
                        alignment: "right",
                      },
                    ],
                    ...((
                      quitarImpuestosRemisiones
                        ? dataSat.Descuento + agregarImpDesc
                        : dataSat.Descuento > 0
                    )
                      ? [
                        [
                          {
                            border: [true, false, false, false],
                            text: "Descuento:",
                            style: "subheader",
                          },
                          {
                            border: [false, false, true, false],
                            text: "- " + dineroDisabledMask(
                              quitarImpuestosRemisiones
                                ? dataSat.Descuento + agregarImpDesc
                                : dataSat.Descuento
                            ),
                            style: "textoChico",
                            alignment: "right",
                          },
                        ],
                      ]
                      : []
                    ),
                    ...(quitarImpuestosRemisiones ? [] : impuestosTotales),
                    [
                      {
                        border: [true, false, false, true],
                        text: "TOTAL:",
                        style: "header",
                        fillColor: "#e8e8e8",
                      },
                      {
                        border: [false, false, true, true],
                        text: dineroDisabledMask(total),
                        style: "header",
                        fillColor: "#e8e8e8",
                        alignment: "right",
                      },
                    ],
                    ...retencionesTotales,
                    ...arraySiHayRetenciones,
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              }] : []),
            ],
          ],
        },
        layout: "noBorders",
      },
      observaciones,
      ...(empresa.textoAdicionalPedidosCotizaciones
        ? [
          {
            style: "tableExample",
            table: {
              widths: ["100%"],
              body: [
                [
                  {
                    text: empresa.textoAdicionalPedidosCotizaciones,
                    style: "textoAdicionalPedidosCotizaciones",
                    border: [true, true, true, true],
                    margin: [0, 0, 0, 5],
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
              hLineWidth: function (i, node) {
                return i === 0 || i === node.table.body.length ? 1 : 1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 1;
              },
              hLineColor: function (i, node) {
                return "#adaaaa";
              },
              vLineColor: function (i, node) {
                return "#adaaaa";
              },
              hLineStyle: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                  return null;
                }
                return { dash: { length: 2, space: 1 } };
              },
              vLineStyle: function (i, node) {
                if (i === 0 || i === node.table.widths.length) {
                  return null;
                }
                return { dash: { length: 2 } };
              },
            },
          },
        ]
        : []),
      ...(empresa?.camposFirmaVentas
        ? [BloqueFirmasPdf([{ titulo: "Entregó" }, { titulo: "Recibió" }])]
        : []),
    ],
    footer: (currentPage, pageCount) => ({
      text: `Página ${currentPage} de ${pageCount}`,
      alignment: "right",
      fontSize: 8,
      color: "#888",
      margin: [0, 0, 30, 0],
    }),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: {
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      tablaSinMargen: {
        margin: [0, 0, 0, 0],
      },
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      textoChico: {
        fontSize: 8,
      },
      textoAdicionalPedidosCotizaciones: {
        fontSize: empresa.tamañoTextoAdicionalPedidosCotizaciones || 8,
      },
      textoChicoData: {
        fontSize: 6,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
      textoTablaChico: {
        fontSize: 6,
        italics: false,
      },
      descuentoPartida: {
        fontSize: 5,
        color: "#777",
      }
    },
    pageSize: "LETTER",
  };
  return dd;
};

export default pedidoPdf;
